import { Text } from "@mantine/core";

interface MultilineTextProps {
  text: string;
  textProps?: React.ComponentProps<typeof Text>;
}

export const MultilineText = ({ text, textProps }: MultilineTextProps) => {
  return (
    <>
      {text.split("\n").map((line, index) => (
        <Text key={index} {...textProps}>
          {line}
        </Text>
      ))}
    </>
  );
};
